// client/src/components/Admin/Dashboard/_shared/KpiCard.js
//
// M06 Fase 4 - Card reutilizable de KPI con icono, titulo, valor grande
// y subtitulo opcional. Soporta `loading` (skeleton interno) y `actions`
// (slot para botones de drill-down).

import React from "react";
import styles from "./KpiCard.module.scss";

export function KpiCard({
  title,
  value,
  subtitle,
  icon,
  actions,
  loading = false,
}) {
  return (
    <div className={styles.kpiCard}>
      <div className={styles.header}>
        <div className={styles.title}>{title}</div>
        {icon ? <div className={styles.icon}>{icon}</div> : null}
      </div>
      {loading ? (
        <div className={styles.skeleton} />
      ) : (
        <div className={styles.value}>{value}</div>
      )}
      {subtitle ? <div className={styles.subtitle}>{subtitle}</div> : null}
      {actions ? <div className={styles.actions}>{actions}</div> : null}
    </div>
  );
}
